<template>
    <div v-if="componentData" class="wrapper Video">
        <a :href="componentData.videoLink" data-fancybox="video-gallery">
            <img :src="componentData.image.data.attributes.url"  :alt="componentData.image.data.attributes.alternativeText"/>
            <span class="iconVideo"><play-icon/></span>
        </a>
    </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'

import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import PlayIcon from '../svg/PlayIcon.vue'

export default defineComponent({
    components:{
        PlayIcon
    },
    props:{
        componentData: {
            type: Object,
            required: false
        },
    },
    setup(props) {
        const homeurl: string = import.meta.env.VITE_API_URL;

        Fancybox.bind('[data-fancybox="video-gallery"]', {
            //
        });

        return {
            homeurl
        };
    }
})

</script>

<style scoped>
/* @import '~flickity/dist/flickity.css'; */
</style>
